import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_195: DocMigration = {
  maxSchemaVersion: "0.0.195",
  description: "Make Param type extend DocEntityBase properly",
  apply(json: any) {
    // Update elevations table
    Object.entries(json?.elevations ?? {}).forEach(([elevationId], index) => {
      const elevation = json.elevations[elevationId];

      // Rename prettyName to name
      elevation.name = elevation.prettyName;
      delete elevation.prettyName;

      // Add sortIndex if it doesn't already exist
      if (typeof elevation.sortIndex !== "number") {
        elevation.sortIndex = index;
      }
    });

    // Update params table
    Object.entries(json?.params ?? {}).forEach(([paramId], index) => {
      const param = json.params[paramId];

      // Add id field
      param.id = paramId;

      // Add entityType field
      param.entityType = "PARAM";

      // Rename prettyName to name
      param.name = param.prettyName;
      delete param.prettyName;

      // Add sortIndex if it doesn't already exist
      if (typeof param.sortIndex !== "number") {
        param.sortIndex = index;
      }

      // Delete invalid paramValues entries
      // Added due to presence of string values in portico.home test home, likely due to oversight
      // in previous DocMigration scripts
      Object.keys(param?.paramValues ?? {}).forEach((paramValueId) => {
        const paramValue = param.paramValues[paramValueId];

        if (typeof paramValue !== "object") {
          delete param.paramValues[paramValueId];
        }
      });

      // Update paramValues table
      Object.entries(param?.paramValues ?? {}).forEach(([paramValueId], index) => {
        const paramValue = param.paramValues[paramValueId];

        // Add parentId
        paramValue.parentId = paramId;

        // Rename prettyName to name
        paramValue.name = paramValue.prettyName;
        delete paramValue.prettyName;

        // Add sortIndex if it doesn't already exist
        if (typeof paramValue.sortIndex !== "number") {
          paramValue.sortIndex = index;
        }
      });
    });

    return json;
  },
};

export default migration_0_0_195;
